// client/src/components/common/Unauthorized.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Paper,
  Box,
  Button
} from '@mui/material';
import { Warning as WarningIcon, Dashboard as DashboardIcon } from '@mui/icons-material';

const Unauthorized = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ mt: 8 }}>
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          mb: 3
        }}>
          <WarningIcon sx={{ fontSize: 64, color: 'warning.main', mb: 2 }} />
          <Typography variant="h4" gutterBottom>
            {t('unauthorized')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('unauthorizedMessage')}
          </Typography>
        </Box>
        <Button
          variant="contained"
          startIcon={<DashboardIcon />}
          onClick={() => navigate('/dashboard')}
        >
          {t('backToDashboard')}
        </Button>
      </Paper>
    </Container>
  );
};

export default Unauthorized;
